import { Stack, Typography } from "@mui/material"
import { Box } from "@mui/system"

export const VBagLabel = ({ order }) => {
    return (
        <Box sx={{
            margin: '1em',
            border: '1px solid black',
            borderRadius: 5,
            justifyContent: 'center'
        }}>
            <Stack spacing={1} sx={{ p: '1em' }}>
                <Typography variant='h4'>{order.student}</Typography>
                <Typography variant='h5'>{order.school}</Typography>
                <Typography variant='h4'>{order.grade}</Typography>
            </Stack>
        </Box>
    )
}